var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7083 6.29163C21.2606 6.29163 21.7083 6.73934 21.7083 7.29163V17.7916C21.7083 18.3439 21.2606 18.7916 20.7083 18.7916C20.156 18.7916 19.7083 18.3439 19.7083 17.7916L19.708 9.70463L7.70711 21.7071C7.34662 22.0676 6.77939 22.0953 6.3871 21.7903L6.29289 21.7071C5.90237 21.3165 5.90237 20.6834 6.29289 20.2929L18.293 8.29163H10.2083C9.6955 8.29163 9.27283 7.90559 9.21506 7.40825L9.20833 7.29163C9.20833 6.73934 9.65605 6.29163 10.2083 6.29163H20.7083Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOutline);
export default __webpack_public_path__ + "static/media/link_outline.b5db6ab3844b3856076002279128cffd.svg";
export { ForwardRef as ReactComponent };